function copyToClipboard(element){

  let copyTitle = $(element).find('input.copy-title').val();
  $(element).find('input.copy-link').select();
  document.execCommand("copy"); 

  Packs.application.largeNotification("success",I18n.t("flash.actions.link_copied_title"), I18n.t("flash.actions.link_copied_text", { copyTitle: copyTitle }), Packs.application.currentTime());
}

export {copyToClipboard};